import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonProps } from '@makyoapp/makyo-ui'

interface SaveButtonProps extends ButtonProps {
  isLoading: boolean
  label?: React.ReactNode
  iconOnly?: boolean
}

export function SaveButton({ disabled, label, isLoading, iconOnly, ...rest }: SaveButtonProps) {
  const { t } = useTranslation()
  return (
    <Button className='flex-c' {...rest} disabled={disabled || isLoading}>
      {isLoading && <span className='loading spin' />}
      {!isLoading && iconOnly === true && label}
      {iconOnly !== true && <span>{label || t('Save')}</span>}
    </Button>
  )
}
